import React, { memo, useContext, useEffect } from 'react';

import { type FrameProps, type RenderFn } from '@atlassian/forge-ui-types';
import { FrameCount } from '../../../provider/FrameCountProvider';
import { forgePropsAreEqual } from '../../utils/forgePropsAreEqual';
const Frame = ({
	forgeDoc,
	IframeRenderer,
}: Parameters<RenderFn>[0] & {
	IframeRenderer: (inputProps: FrameProps) => JSX.Element;
}) => {
	const { setFrameCount } = useContext(FrameCount);

	useEffect(() => {
		setFrameCount((prevCount) => prevCount + 1);
		return () => setFrameCount((prevCount) => prevCount - 1);
	}, [setFrameCount]);

	const { dispatch, resource, height, width } = forgeDoc.props as FrameProps;
	return <IframeRenderer dispatch={dispatch} resource={resource} height={height} width={width} />;
};

const FrameMemo = memo(Frame, forgePropsAreEqual);

export const makeFrame = (IframeRenderer: (inputProps: FrameProps) => JSX.Element) => {
	return (props: Parameters<RenderFn>[0]): React.JSX.Element => (
		<FrameMemo {...props} IframeRenderer={IframeRenderer} />
	);
};
